import React, { useContext } from 'react';

import { AssignDriver } from '../assign-driver';
import { ExternalDepsContext } from '../context';

type Props = {
	taskId: number;
	driverId: number;
};

const UserIdCell = ({ taskId, driverId }: Props) => {
	const { isAllowedToAssignSpecificTask } = useContext(ExternalDepsContext);

	return (
		<AssignDriver
			taskId={taskId}
			driverId={driverId}
			isAllowedToAssignSpecificTask={isAllowedToAssignSpecificTask}
		/>
	);
};

export default UserIdCell;
